import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  //max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading three">Get in Touch</h2>
      <p>
        Have any question? or have some advice for me or just want to say Hi 👋. The easiest way to
        reach out to me is via an email. I’ll do my best to get back to you!
      </p>

      <p>&nbsp;</p>
      <div className="button-wrapper">
        <a href={`mailto:${email}`}>
          <svg height="60" xmlns="http://www.w3.org/2000/svg">
            <rect className="button-wrapper__shape" height="60" width="100%" rx="0"></rect>
          </svg>
          <div className="button-wrapper__text">Say Hello</div>
        </a>
      </div>
    </StyledContactSection>
  );
};

export default Contact;
